import { Box, CircularProgress, Dialog, DialogActions } from "@mui/material";
import { ICONS } from "../constants/enums";
import Heading from "./Heading";

type CircularProgressDialogProps = {
  icon?: ICONS;
  text: string;
  width?: "sm" | "md" | "lg";
  dialogOpen: boolean;
  showButtons?: boolean;
};

const CircularProgressDialog = ({
  icon,
  text,
  width = "md",
  dialogOpen,
  showButtons = false,
}: CircularProgressDialogProps) => {
  return (
    <Dialog open={dialogOpen} maxWidth={width} fullWidth>
      <Box
        sx={{
          padding: "26px 0px 0px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
        }}
      >
        <Box sx={{ textAlign: "center", color: "warning.main" }}>
          <span
            className="material-symbols-outlined"
            style={{ fontSize: "60px" }}
          >
            {icon}
          </span>
        </Box>
        <Box
          sx={{
            margin: "20px",
          }}
        >
          <Heading text={text} type="h5" isBold />
        </Box>
        <CircularProgress sx={{ margin: 2 }} />

        {showButtons && (
          <DialogActions
            data-testid="dialog-actions"
            sx={{
              m: "10px 0px 22px 0px",
              display: "flex",
              justifyContent: "center",
              columnGap: "20px",
              alignItems: "center",
            }}
          >
            {/* Add optional buttons here if needed */}
          </DialogActions>
        )}
      </Box>
    </Dialog>
  );
};

export default CircularProgressDialog;
